import type { PhoneType } from "../../../../clients/graphqlTypes.js";
import type { OnboardingFormVariant } from "./onboardingUpdateInput.js";

/** A new phone starts as a landline for a business and as a mobile for an owner. */
export const getDefaultOnboardingPhoneType = (
  variant: OnboardingFormVariant
): PhoneType => (variant === "business" ? "WORK" : "MOBILE");

/**
 * The phone types of the form step: Landline (`WORK`) and Mobile. A stored
 * phone of another type keeps it: the type is listed as an extra option under
 * its usual label, so the select shows it and the save never rewrites it. The
 * legacy `PRIVATE` has no label in the app; it is named `unnamedType` rather
 * than shown as a blank option.
 */
export function buildOnboardingPhoneTypeOptions({
  storedType,
  landline,
  unnamedType,
  typeLabels,
}: {
  storedType: PhoneType | null | undefined;
  landline: string;
  unnamedType: string;
  typeLabels: Record<PhoneType, string>;
}): { id: PhoneType; label: string; value: PhoneType }[] {
  const options: { id: PhoneType; label: string; value: PhoneType }[] = [
    { id: "WORK", label: landline, value: "WORK" },
    { id: "MOBILE", label: typeLabels.MOBILE, value: "MOBILE" },
  ];
  if (storedType && !options.some(option => option.value === storedType)) {
    options.push({
      id: storedType,
      label: typeLabels[storedType] || unnamedType,
      value: storedType,
    });
  }
  return options;
}
